import React, { createContext, useContext, useReducer } from "react";
import { scheduleActions } from "./scheduleStore.actions";
import {
  scheduleInitState,
  ScheduleActions,
  ScheduleState,
  scheduleStateReducer,
} from "./scheduleStore.reducer";

export type ScheduleDispatch = (action: ScheduleActions) => void;

const ScheduleStateContext = createContext<ScheduleState | undefined>(undefined);
const ScheduleDispatchContext = createContext<ScheduleDispatch | undefined>(
  undefined,
);

export const ScheduleStoreProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(scheduleStateReducer, scheduleInitState);

  return (
    <ScheduleStateContext.Provider value={state}>
      <ScheduleDispatchContext.Provider value={dispatch}>
        {children}
      </ScheduleDispatchContext.Provider>
    </ScheduleStateContext.Provider>
  );
};

export const useScheduleStore = () => {
  const state = useContext(ScheduleStateContext);
  const dispatch = useContext(ScheduleDispatchContext);

  if (state === undefined || dispatch === undefined) {
    throw new Error("useScheduleStore must be used within a ScheduleStoreProvider");
  }

  const actions = scheduleActions(dispatch, state);
  return [state, actions, dispatch] as const;
};
